import QuantityAmount from './QuantityAmount';
export default QuantityAmount;
